"use client"
import { useContext, createContext } from "react"
import type {
	EmployeeOutput,
	OrganizationOutput,
	UserOutput,
} from "@/lib/schemas/output"

export const AuthContext = createContext<UserOutput | null>(null)

type Props = {
	children?: React.ReactNode
	initial: UserOutput | null
}

export function AuthProvider({ children, initial }: Props) {
	return (
		<AuthContext.Provider value={initial}>{children}</AuthContext.Provider>
	)
}

export const useAuth = <T extends string = "none">() =>
	useContext(AuthContext)! as T extends "employee"
		? EmployeeOutput
		: T extends "organization"
		? OrganizationOutput
		: UserOutput
